import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FreelancePoolConfiguration,
  OperativeZoneConfiguration,
  ProductData,
  ProductInformation,
} from 'src/app/models/pool-parameters/pool-parameters.model';
import { catchError, Observable, of, throwError } from 'rxjs';
import {
  GetPaginatedFreelancePoolServicesRequest,
  PoolService,
  PoolServiceNotStarted,
} from 'src/app/shared/pool-management/interface/pool-service.interface';

import {
  ServiceGuidRequest,
  BooleanResponse,
  UpdatePriceRequest,
  RemoveFreelancePoolRequest,
} from 'src/app/models/pool-manager/service-manager.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PoolManagerService {
  url = environment.url;
  // local_url = "http://localhost:3000";

  // exampleData: PoolService = {
  //   freelancePoolServices: [
  //     {
  //       toppingNames: [],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       licensePlate: '12345',
  //       orderHash: 'B-752F3E8E',
  //       nodeStatus: 1,
  //       zoneName: 'Madrid',
  //       clientName: 'Alberto Garcia',
  //       productName: 'VAR WASH',
  //       driverName: 'Juan Conductor',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Tunnel wash'],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-18T12:00:00 Europe/Madrid (+02)',
  //       licensePlate: '67890',
  //       orderHash: 'B-12345678',
  //       nodeStatus: 2,
  //       zoneName: 'Barcelona',
  //       productName: 'CAR WASH',
  //       driverName: 'Juan Conductor 2',
  //       clientName: 'Rodolfo Garcia',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Tunnel wash', 'Wax'],
  //       assignedEndDate: '2025-06-01T14:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-01T12:30:00 Europe/Madrid (+02)',
  //       licensePlate: 'MAD123',
  //       orderHash: 'B-111AAA',
  //       nodeStatus: 1,
  //       zoneName: 'Madrid',
  //       clientName: 'Carlos Ruiz',
  //       productName: 'FULL WASH',
  //       driverName: 'David López',
  //       price: 30.0,
  //       userBidCount: 2,
  //     },
  //     {
  //       toppingNames: ['Interior cleaning'],
  //       assignedEndDate: '2025-06-02T10:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-02T09:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'BCN789',
  //       orderHash: 'B-222BBB',
  //       nodeStatus: 1,
  //       zoneName: 'Barcelona',
  //       clientName: 'Ana Torres',
  //       productName: 'INTERIOR WASH',
  //       driverName: 'Laura Méndez',
  //       price: 20.5,
  //       userBidCount: 1,
  //     },
  //     {
  //       toppingNames: [],
  //       assignedEndDate: '2025-06-03T18:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-03T17:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'VAL456',
  //       orderHash: 'B-333CCC',
  //       nodeStatus: 0,
  //       zoneName: 'Valencia',
  //       clientName: 'Jorge Navarro',
  //       productName: 'BASIC WASH',
  //       driverName: 'Sergio Díaz',
  //       price: 10.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Ceramic coating', 'Tire shine'],
  //       assignedEndDate: '2025-06-05T16:30:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-05T14:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'SEV012',
  //       orderHash: 'B-444DDD',
  //       nodeStatus: 2,
  //       zoneName: 'Sevilla',
  //       clientName: 'Marta Jiménez',
  //       productName: 'PREMIUM WASH',
  //       driverName: 'Pablo Castro',
  //       price: 45.75,
  //       userBidCount: 4,
  //     },
  //   ],
  // };
  // exampleData2: PoolServiceNotStarted = {
  //   pendingServices: [
  //     {
  //       toppingNames: ['Tunnel wash'],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-25T12:00:00 Europe/Madrid (+02)',
  //       licensePlate: '12345',
  //       orderHash: 'B-752F3E8E',
  //       nodeStatus: 0,
  //       zoneName: 'Madrid',
  //       productName: 'CAR WASH',
  //       driverName: 'Juan Conductor',
  //       clientName: 'Carlos Garcia',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: [],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-26T12:00:00 Europe/Madrid (+02)',
  //       licensePlate: '67890',
  //       orderHash: 'B-12345678',
  //       nodeStatus: 4,
  //       zoneName: 'Barcelona',
  //       productName: 'CAR WASH',
  //       driverName: 'Juan Conductor',
  //       clientName: 'Eyker Garcia',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: [],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       licensePlate: '12345',
  //       orderHash: 'B-752F3E8E',
  //       nodeStatus: 1,
  //       zoneName: 'Madrid',
  //       clientName: 'Alberto Garcia',
  //       productName: 'VAR WASH',
  //       driverName: 'Juan Conductor',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Tunnel wash'],
  //       assignedEndDate: '2025-04-16T16:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-04-18T12:00:00 Europe/Madrid (+02)',
  //       licensePlate: '67890',
  //       orderHash: 'B-12345678',
  //       nodeStatus: 2,
  //       zoneName: 'Barcelona',
  //       productName: 'CAR WASH',
  //       driverName: 'Juan Conductor 2',
  //       clientName: 'Rodolfo Garcia',
  //       price: 0.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Tunnel wash', 'Wax'],
  //       assignedEndDate: '2025-06-01T14:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-01T12:30:00 Europe/Madrid (+02)',
  //       licensePlate: 'MAD123',
  //       orderHash: 'B-111AAA',
  //       nodeStatus: 1,
  //       zoneName: 'Madrid',
  //       clientName: 'Carlos Ruiz',
  //       productName: 'FULL WASH',
  //       driverName: 'David López',
  //       price: 30.0,
  //       userBidCount: 2,
  //     },
  //     {
  //       toppingNames: ['Interior cleaning'],
  //       assignedEndDate: '2025-06-02T10:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-02T09:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'BCN789',
  //       orderHash: 'B-222BBB',
  //       nodeStatus: 1,
  //       zoneName: 'Barcelona',
  //       clientName: 'Ana Torres',
  //       productName: 'INTERIOR WASH',
  //       driverName: 'Laura Méndez',
  //       price: 20.5,
  //       userBidCount: 1,
  //     },
  //     {
  //       toppingNames: [],
  //       assignedEndDate: '2025-06-03T18:00:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-03T17:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'VAL456',
  //       orderHash: 'B-333CCC',
  //       nodeStatus: 0,
  //       zoneName: 'Valencia',
  //       clientName: 'Jorge Navarro',
  //       productName: 'BASIC WASH',
  //       driverName: 'Sergio Díaz',
  //       price: 10.0,
  //       userBidCount: 0,
  //     },
  //     {
  //       toppingNames: ['Ceramic coating', 'Tire shine'],
  //       assignedEndDate: '2025-06-05T16:30:00 Europe/Madrid (+02)',
  //       assignedStartDate: '2025-06-05T14:00:00 Europe/Madrid (+02)',
  //       licensePlate: 'SEV012',
  //       orderHash: 'B-444DDD',
  //       nodeStatus: 2,
  //       zoneName: 'Sevilla',
  //       clientName: 'Marta Jiménez',
  //       productName: 'PREMIUM WASH',
  //       driverName: 'Pablo Castro',
  //       price: 45.75,
  //       userBidCount: 4,
  //     },
  //   ],
  // };

  productsDetails = {
    productInformationData: [
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '00000000-0000-0000-0000-000000000000',
            productDescription: '0 - 15',
            poolPrice: 500.0,
            premiumPrice: 20.5,
            premiumPercentatge: 21,
            hybridPrice: 18.5,
            hybridPercentatge: 17,
            b2bPrice: 16.0,
            b2bPercentatge: 15,
            b2cPrice: 14.0,
            b2cPercentatge: 13,
          },
        ],
        IsAvailableForFreelancePool: false,
        verticalType: 1,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '11111111-1111-1111-1111-111111111111',
            productDescription: '16 - 30',
            poolPrice: 600.0,
            premiumPrice: 25.5,
            premiumPercentatge: 22,
            hybridPrice: 22.5,
            hybridPercentatge: 18,
            b2bPrice: 20.0,
            b2bPercentatge: 16,
            b2cPrice: 18.0,
            b2cPercentatge: 14,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 2,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '22222222-2222-2222-2222-222222222222',
            productDescription: '31 - 45',
            poolPrice: 700.0,
            premiumPrice: 30.5,
            premiumPercentatge: 23,
            hybridPrice: 27.5,
            hybridPercentatge: 19,
            b2bPrice: 25.0,
            b2bPercentatge: 17,
            b2cPrice: 22.0,
            b2cPercentatge: 15,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 3,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '33333333-3333-3333-3333-333333333333',
            productDescription: '46 - 60',
            poolPrice: 800.0,
            premiumPrice: 35.5,
            premiumPercentatge: 24,
            hybridPrice: 32.5,
            hybridPercentatge: 20,
            b2bPrice: 30.0,
            b2bPercentatge: 18,
            b2cPrice: 26.0,
            b2cPercentatge: 16,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 4,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '44444444-4444-4444-4444-444444444444',
            productDescription: '61 - 75',
            poolPrice: 900.0,
            premiumPrice: 40.5,
            premiumPercentatge: 25,
            hybridPrice: 37.5,
            hybridPercentatge: 21,
            b2bPrice: 35.0,
            b2bPercentatge: 19,
            b2cPrice: 30.0,
            b2cPercentatge: 17,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 5,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '55555555-5555-5555-5555-555555555555',
            productDescription: '76 - 90',
            poolPrice: 1000.0,
            premiumPrice: 45.5,
            premiumPercentatge: 26,
            hybridPrice: 42.5,
            hybridPercentatge: 22,
            b2bPrice: 40.0,
            b2bPercentatge: 20,
            b2cPrice: 34.0,
            b2cPercentatge: 18,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 6,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '66666666-6666-6666-6666-666666666666',
            productDescription: '91 - 105',
            poolPrice: 1100.0,
            premiumPrice: 50.5,
            premiumPercentatge: 27,
            hybridPrice: 47.5,
            hybridPercentatge: 23,
            b2bPrice: 45.0,
            b2bPercentatge: 21,
            b2cPrice: 38.0,
            b2cPercentatge: 19,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 7,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '77777777-7777-7777-7777-777777777777',
            productDescription: '106 - 120',
            poolPrice: 1200.0,
            premiumPrice: 55.5,
            premiumPercentatge: 28,
            hybridPrice: 52.5,
            hybridPercentatge: 24,
            b2bPrice: 50.0,
            b2bPercentatge: 22,
            b2cPrice: 42.0,
            b2cPercentatge: 20,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 8,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '88888888-8888-8888-8888-888888888888',
            productDescription: '121 - 135',
            poolPrice: 1300.0,
            premiumPrice: 60.5,
            premiumPercentatge: 29,
            hybridPrice: 57.5,
            hybridPercentatge: 25,
            b2bPrice: 55.0,
            b2bPercentatge: 23,
            b2cPrice: 46.0,
            b2cPercentatge: 21,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 9,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '99999999-9999-9999-9999-999999999999',
            productDescription: '136 - 150',
            poolPrice: 1400.0,
            premiumPrice: 65.5,
            premiumPercentatge: 30,
            hybridPrice: 62.5,
            hybridPercentatge: 26,
            b2bPrice: 60.0,
            b2bPercentatge: 24,
            b2cPrice: 50.0,
            b2cPercentatge: 22,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 10,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
            productDescription: '151 - 165',
            poolPrice: 1500.0,
            premiumPrice: 70.5,
            premiumPercentatge: 31,
            hybridPrice: 67.5,
            hybridPercentatge: 27,
            b2bPrice: 65.0,
            b2bPercentatge: 25,
            b2cPrice: 54.0,
            b2cPercentatge: 23,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 11,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
            productDescription: '166 - 180',
            poolPrice: 1600.0,
            premiumPrice: 75.5,
            premiumPercentatge: 32,
            hybridPrice: 72.5,
            hybridPercentatge: 28,
            b2bPrice: 70.0,
            b2bPercentatge: 26,
            b2cPrice: 58.0,
            b2cPercentatge: 24,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 12,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'cccccccc-cccc-cccc-cccc-cccccccccccc',
            productDescription: '181 - 195',
            poolPrice: 1700.0,
            premiumPrice: 80.5,
            premiumPercentatge: 33,
            hybridPrice: 77.5,
            hybridPercentatge: 29,
            b2bPrice: 75.0,
            b2bPercentatge: 27,
            b2cPrice: 62.0,
            b2cPercentatge: 25,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 13,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'dddddddd-dddd-dddd-dddd-dddddddddddd',
            productDescription: '196 - 210',
            poolPrice: 1800.0,
            premiumPrice: 85.5,
            premiumPercentatge: 34,
            hybridPrice: 82.5,
            hybridPercentatge: 30,
            b2bPrice: 80.0,
            b2bPercentatge: 28,
            b2cPrice: 66.0,
            b2cPercentatge: 26,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 14,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
            productDescription: '211 - 225',
            poolPrice: 1900.0,
            premiumPrice: 90.5,
            premiumPercentatge: 35,
            hybridPrice: 87.5,
            hybridPercentatge: 31,
            b2bPrice: 85.0,
            b2bPercentatge: 29,
            b2cPrice: 70.0,
            b2cPercentatge: 27,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 15,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              'ffffffff-ffff-ffff-ffff-ffffffffffff',
            productDescription: '226 - 240',
            poolPrice: 2000.0,
            premiumPrice: 95.5,
            premiumPercentatge: 36,
            hybridPrice: 92.5,
            hybridPercentatge: 32,
            b2bPrice: 90.0,
            b2bPercentatge: 30,
            b2cPrice: 74.0,
            b2cPercentatge: 28,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 16,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '01234567-89ab-cdef-0123-456789abcdef',
            productDescription: '241 - 255',
            poolPrice: 2100.0,
            premiumPrice: 100.5,
            premiumPercentatge: 37,
            hybridPrice: 97.5,
            hybridPercentatge: 33,
            b2bPrice: 95.0,
            b2bPercentatge: 31,
            b2cPrice: 78.0,
            b2cPercentatge: 29,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 17,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '12345678-9abc-def0-1234-56789abcdef0',
            productDescription: '256 - 270',
            poolPrice: 2200.0,
            premiumPrice: 105.5,
            premiumPercentatge: 38,
            hybridPrice: 102.5,
            hybridPercentatge: 34,
            b2bPrice: 100.0,
            b2bPercentatge: 32,
            b2cPrice: 82.0,
            b2cPercentatge: 30,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 18,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '23456789-0abc-def1-2345-67890abcdef1',
            productDescription: '271 - 285',
            poolPrice: 2300.0,
            premiumPrice: 110.5,
            premiumPercentatge: 39,
            hybridPrice: 107.5,
            hybridPercentatge: 35,
            b2bPrice: 105.0,
            b2bPercentatge: 33,
            b2cPrice: 86.0,
            b2cPercentatge: 31,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 900,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '34567890-1abc-def2-3456-78901abcdef2',
            productDescription: '286 - 300',
            poolPrice: 2400.0,
            premiumPrice: 115.5,
            premiumPercentatge: 40,
            hybridPrice: 112.5,
            hybridPercentatge: 36,
            b2bPrice: 110.0,
            b2bPercentatge: 34,
            b2cPrice: 90.0,
            b2cPercentatge: 32,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 901,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '45678901-2abc-def3-4567-89012abcdef3',
            productDescription: '301 - 315',
            poolPrice: 2500.0,
            premiumPrice: 120.5,
            premiumPercentatge: 41,
            hybridPrice: 117.5,
            hybridPercentatge: 37,
            b2bPrice: 115.0,
            b2bPercentatge: 35,
            b2cPrice: 94.0,
            b2cPercentatge: 33,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 902,
      },
      {
        productData: [
          {
            freelancePoolConfigurationGuid:
              '56789012-3abc-def4-5678-90123abcdef4',
            productDescription: '316 - 330',
            poolPrice: 2600.0,
            premiumPrice: 125.5,
            premiumPercentatge: 42,
            hybridPrice: 122.5,
            hybridPercentatge: 38,
            b2bPrice: 120.0,
            b2bPercentatge: 36,
            b2cPrice: 98.0,
            b2cPercentatge: 34,
          },
        ],
        IsAvailableForFreelancePool: true,
        verticalType: 1000,
      },
    ],
  };

  poolConfiguration = {
    freelancePoolConfiguration: [
      {
        operativeZoneConfigurationGuid: '00000000-0000-0000-0000-000000000000',
        description: 'Fixed Fee',
        timeLimit: 0,
      },
      {
        operativeZoneConfigurationGuid: '00000000-0000-0000-0000-000000000000',
        description: 'Urgency Fee',
        timeLimit: 0,
      },
    ],
  };

  constructor(private http: HttpClient) {}

  // Pending to remove
  getZones(): any {
    return this.http.get(`${this.url}/zones`);
  }


  getPaginatedFreelancePoolServices(body?: GetPaginatedFreelancePoolServicesRequest): Observable<PoolService> {
    return this.http.post<PoolService>(
      `${this.url}/pool-management/GetPaginatedHistoricPoolServices`,
      body
    );
  }

  getNotStartedPools(): Observable<PoolServiceNotStarted> {
    return this.http.get<PoolServiceNotStarted>(
      `${this.url}/pool-management/GetPendingPoolServices`
    );
  }

  getPoolProductsByZone(zoneId: string): Observable<ProductInformation> {
    const params = new HttpParams().set('zoneGuid', zoneId);

    return this.http.get<ProductInformation>(
      `${this.url}/freelance-pool-configuration/GetFreelancePoolConfigurationByZone`,
      { params }
    );
  }

  getOperativeConfigurationByZone(
    zoneId: string
  ): Observable<FreelancePoolConfiguration> {
    // Dont exist the url
    const params = new HttpParams().set('zoneGuid', zoneId);
    return this.http.get<FreelancePoolConfiguration>(
      `${this.url}/operative-zone-configuration/GetOperativeZoneConfigurationByZone`,
      { params }
    );
  }

  updateOperativeZoneConfiguration(body: OperativeZoneConfiguration) {
    return this.http.post(
      `${this.url}/operative-zone-configuration/UpdateOperativeZoneConfiguration`,
      body
    );
  }

  updateFreelancePoolConfigurationPrice(body: ProductData) {
    //Dont test because  we dont have data in products
    return this.http.put(
      `${this.url}/freelance-pool-configuration/UpdateFreelancePoolConfigurationPrice`,
      body
    );
    // return new Observable((observer) => {
    //   setTimeout(() => {
    //     observer.next({
    //       isSuccess: true,
    //     });
    //     observer.complete();
    //   }, 500);
    // });
  }

  updatePoolConfigurationAvailability(body: {}) {
    //Dont test because  we dont have data in products
    return this.http.put(
      `${this.url}/freelance-pool-configuration/UpdateFreelancePoolConfigurationAvailability`,
      body
    );
    // return new Observable((observer) => {
    //   setTimeout(() => {
    //     observer.next({
    //       isSuccess: true,
    //     });
    //     observer.complete();
    //   }, 500);
    // });
  }

  addServiceToFreelancePool(
    request: ServiceGuidRequest
  ): Observable<BooleanResponse> {
    return this.http
      .put<BooleanResponse>(
        `${this.url}/service-manager/AddServiceToFreelancePool`,
        request
      )
      .pipe(catchError(this.handleError('addServiceToFreelancePool')));
  }

  removeServiceFromFreelancePool(
    request: RemoveFreelancePoolRequest
  ): Observable<BooleanResponse> {
    return this.http
      .put<BooleanResponse>(
        `${this.url}/service-manager/RemoveServiceFromFreelancePool`,
        request
      )
      .pipe(catchError(this.handleError('removeServiceFromFreelancePool')));
  }

  updateFreelanceCustomPrice(
    request: UpdatePriceRequest
  ): Observable<BooleanResponse> {
    return this.http
      .put<BooleanResponse>(
        `${this.url}/service-manager/UpdateFreelanceCustomPrice`,
        request
      )
      .pipe(catchError(this.handleError('updateFreelanceCustomPrice')));
  }

  private handleError(operation: string) {
    return (error: any): Observable<never> => {
      console.error(`ServiceManagerService ${operation} error:`, error);
      const message =
        error?.error?.error ||
        error?.message ||
        `Error en operación ${operation}`;
      return throwError(() => new Error(message));
    };
  }
}
